import { formatTranslation } from 'intl';
import { InspectionTranslationKeys } from 'intl/keys';
import type { TranslationKey } from 'intl/types/translationKey';

export function resolveRichTextCommentLabel(
  intl: Parameters<typeof formatTranslation>[0],
  floatingLabelId?: TranslationKey
): string {
  return floatingLabelId
    ? formatTranslation(intl, floatingLabelId)
    : formatTranslation(intl, InspectionTranslationKeys.comment);
}
